import { Divider as CoreDivider } from '@hopskipdrive/react-components';
import { variables } from '@rideiq/shared/components/variables';
import styled from 'styled-components';

export const FlexRow = styled.div`
  display: flex;
  align-items: center;
  grid-gap: 2rem;
  margin-right: auto;
  justify-content: space-between;
  width: 90%;
  label {
    min-width: 80px;
    margin-right: 20px;
  }

  ${variables.mediaQuery.lessThan('desktop')`
    flex-direction: column;
    align-items: flex-start;
    width: 100%;
    gap: 0;

    label {
      min-width: auto;
      margin-right: 0;
    }
  `}
`;

export const Divider = styled(CoreDivider)`
  margin: 1.5rem 0;
`;
